import EfFooterTc from '@elem/ui/ef-footer-tc';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

export default function TheComp() {
    const { t } = useLang('theProduct.FooterTcA');
    const listA = [
        {
            title: t.rich('text', {
                b: (v: string) => <span className="tc-title">{v}</span>,
            }),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfFooterTc className="footer-tc" list={listA} />
        </div>
    );
}
